import * as React from "react";
import { useEffect } from "react";
import isFunction from "lodash/isFunction";
import Routes from "routing/Routes";
import useHistory from "routing/useHistory";
import usePermissions from "hooks/usePermissions";
const isRequiredPermissionFunction = (f) => isFunction(f);
const withIsPermitted = (Component, requiredPermissions) => (props) => {
  const { isPermitted } = usePermissions();
  const history = useHistory();
  const effectiveRequiredPermissions = isRequiredPermissionFunction(requiredPermissions) ? requiredPermissions(props) : requiredPermissions;
  const hasPermissions = isPermitted(effectiveRequiredPermissions);
  useEffect(() => {
    if (!hasPermissions) {
      history.push(Routes.NOTFOUND);
    }
  }, [effectiveRequiredPermissions, hasPermissions, history]);
  return hasPermissions ? /* @__PURE__ */ React.createElement(Component, { ...props }) : null;
};
export default withIsPermitted;
